export default {
    "Apto Tipo Valle": "https://umbra3d.studio/recorridos/constructora-la-ramada/balcones-de-la-rivera/apto-valle/",
    "Apto Tipo Rio": "https://umbra3d.studio/recorridos/constructora-la-ramada/balcones-de-la-rivera/apto-rio/",
}